import {VoucherPoller} from "./src/VoucherPoller";

const poller = new VoucherPoller(jQuery);
(window as unknown as Record<string, unknown>).vpayVoucherPoller = poller;